import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {BeaconService} from '../services/beacon.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import { FirmService } from '../services/firm.service';
import { Firms } from '../models/firms';

@Component({
    selector: 'app-firm-beacons',
    templateUrl: './firm-beacons.component.html',
    styleUrls: ['./firm-beacons.component.css']
})
export class FirmBeaconsComponent implements OnInit {
    @ViewChild('closeCreateModal') closeCreateModal: ElementRef;
    @ViewChild('closeUpdateModal') closeUpdateModal: ElementRef;
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    private firmId: string;
    public beacons = [];
    public beaconsFirstDeactive = [];
    public beaconsSecondsActive = [];
    public firm: any;
    public searchText;
    flag: string = '';
    loading = false;
    firms = [];
    firmDetail = [];
    constructor(
        private beaconService: BeaconService,
        private router: Router, 
        private route: ActivatedRoute,
        private firmService: FirmService,
        private spinner: NgxSpinnerService) {
    }

    public selectedId;
    public selectedBeacon = {firm: new Firms(), name: '', _id: '', location: {coordinates: ['', '']}, status: '-1'};

    ngOnInit() {
        this.spinner.show();
        this.firm = localStorage.getItem('firm');
        this.firmId = localStorage.getItem('firmId');
        this.flag = this.route.snapshot.paramMap.get('flag');
        if(this.flag === 'varliklar') {
            this.getAllBeaconsForSuperAdmin();
        } else {
            this.getBeaconsByFirm(this.firmId);
        }
        this.getAllFirms();
    }

    getBeaconsByFirm(firmId: string) {
            this.beaconService.getBeaconsByFirm(firmId).subscribe(res => {
                this.beacons = res.dataBeacons;
                this.beacons = [];
                this.beaconsFirstDeactive = [];
                this.beaconsSecondsActive = [];
                res.dataBeacons.forEach(data => {
                    if (!data.status) {
                        this.beaconsFirstDeactive.push(data);
                    } else {
                        this.beaconsSecondsActive.push(data);
                    }
                });
                this.beacons = this.beaconsFirstDeactive.concat(this.beaconsSecondsActive);
                this.spinner.hide();
            }, error => {
                if (error.message === 'Error: Access Denied') {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    this.router.navigate(['/login']);
                    this.spinner.hide();
                } else {
                    this.errorSwal.title = error.status;
                    this.errorSwal.text = error.error;
                    this.errorSwal.show();
                    this.spinner.hide();
                }
            });
    }
    getAllBeaconsForSuperAdmin() {
        this.spinner.show();
        this.flag = this.route.snapshot.paramMap.get('flag');
        if (this.flag === 'varliklar') {
            this.beaconService.getAllBeaconsForSuperAdmin().subscribe(res => {
                this.beacons = res.dataBeacons;
                this.beacons = [];
                this.beaconsFirstDeactive = [];
                this.beaconsSecondsActive = [];
                res.forEach(data => {
                    if (!data.status) {
                        this.beaconsFirstDeactive.push(data);
                    } else {
                        this.beaconsSecondsActive.push(data);
                    }
                });
                this.beacons = this.beaconsFirstDeactive.concat(this.beaconsSecondsActive);
                this.spinner.hide();
            }, error => {
                if (error.message === 'Error: Access Denied') {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    this.router.navigate(['/login']);
                    this.spinner.hide();
                } else {
                    this.errorSwal.title = error.status;
                    this.errorSwal.text = error.error;
                    this.errorSwal.show();
                    this.spinner.hide();
                }
            });            
        }
    }
    createBeacon(name, uuid, lat, lng, status) {
        if (name === '' || name === undefined || uuid === '' || uuid === undefined ||
            parseFloat(lat) === 0 || parseFloat(lng) === 0) {
            this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        const Beacon = {
            name: name,
            uuid: uuid,
            location: {coordinates: [parseFloat(lat), parseFloat(lng)]},
            firm: this.firmId,
            status: status
        };
        this.beaconService.createBeacon(Beacon).subscribe(res => {
            this.spinner.hide();
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            this.closeCreateModal.nativeElement.click();
            if(this.flag === 'varliklar') {
                this.getAllBeaconsForSuperAdmin();
            } else {
                this.getBeaconsByFirm(this.firmId);
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    deleteBeacon(id) {
        if (id === '' || id === undefined) {
            this.errorSwal.title = 'Beacon id alınamadı!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        this.beaconService.deleteBeacon(id).subscribe(res => {
            this.spinner.hide();
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            if(this.flag === 'varliklar') {
                this.getAllBeaconsForSuperAdmin();
            } else {
                this.getBeaconsByFirm(id);
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    updateBeacon(name, uuid, lat, lng, status) {
        if (name === '' || name === undefined || uuid === '' || uuid === undefined ||
            parseFloat(lat) === 0 || parseFloat(lng) === 0 || status === '' || status === '-1') {
            this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        const Beacon = {
            name: name,
            uuid: uuid,
            location: {coordinates: [parseFloat(lat), parseFloat(lng)]},
            firm: this.firmId,
            status: status
        };

        this.beaconService.updateBeacon(Beacon, this.selectedId).subscribe(res => {
            this.spinner.hide();
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            this.closeUpdateModal.nativeElement.click();
            if(this.flag === 'varliklar') {
                this.getAllBeaconsForSuperAdmin();
            } else {
                this.getBeaconsByFirm(this.firmId);
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    getBeaconById(id) {
        this.spinner.show();
        this.beaconService.getBeaconById(id).subscribe(res => {
            if (res.success) {
                this.selectedBeacon = res.beacon;
                this.spinner.hide();
            } else {
                this.errorSwal.title = 'Hata!';
                this.errorSwal.text = res.message;
                this.errorSwal.show();
                this.spinner.hide();
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    selected(id) {
        this.selectedId = id;
        this.getBeaconById(id);
    }

    getAllFirms() {
        this.firmService.getAllFirms().subscribe(res => {
            if (res.success) {
                this.firms = res.firms;
                for (const firm of this.firms) {
                    this.firmDetail.push(firm._id);
                }
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
            }
        });
    }
    onSelectBeaconCreate() {
        this.firmId = this.selectedBeacon.firm._id;
    }
    onSelectBeaconUpdate() {
        this.firmId = this.selectedBeacon.firm._id;
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/firm-beacons/firm-beacons.component.ts